// src/pages/BookDetail.js
import { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';

import { getBookDetails, getSimilarBooks } from '@/api/bookApi';
import BookShelf from '@/components/BookShelf';
import { BookSkeleton, DescriptionSkeleton } from '@/components/BookSkeleton';
import ErrorDisplay from '@/components/ErrorDisplay';
import './BookDetail.css'

const BookDetail = () => {
  const { id } = useParams();
  const location = useLocation();
  const { state } = location || {}
  const [book, setBook] = useState(null);
  const [readingTime, setReadingTime] = useState('');
  const [similarBooks, setSimilarBooks] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  function calculteReadingTime(pageCount) {
    const wordCount = pageCount * 300; // Assuming 300 words per page
    const readingTimeInMinutes = Math.ceil(wordCount / 200); // Average WPM is 200
    const hours = Math.floor(readingTimeInMinutes / 60);
    const minutes = readingTimeInMinutes % 60;
    setReadingTime(`${hours} hr ${minutes} min`);
  }


  useEffect(() => {
    const fetchBookData = async () => {
      try {
        setIsLoading(true)
        getBookDetails(id).then(bookData => {
          setBook(bookData);
          calculteReadingTime(bookData.pageCount)
          setIsLoading(false);
          getSimilarBooks(bookData.ref).then(similarBooksData => {
            setSimilarBooks(similarBooksData.slice(1).sort(() => Math.random() - 0.5).map((book) => (
              { image: book.cover, title: book.title, author: book.author, id: book.id })));
          });
        });

      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchBookData();
  }, [id]);

  const Loading = () => {
    return <div className='object-cover object-center w-full rounded skeleton-item largeCover h-1/2 lg:w-1/4'>&nbsp;</div>
  };

  if (error) return <ErrorDisplay error={error} />;

  const textLoading = <div className='animate-pulse'>
    <div className="w-5/6 h-5 mx-auto bg-gray-200 rounded "></div>
  </div>

  return (
    <main className="min-h-[calc(100vh-4rem)]">
      <section className="overflow-hidden">
        <div className="container px-5 pt-32 pb-4 mx-auto sm:py-24">
          <div className="flex flex-wrap items-center mx-auto lg:max-w-5xl">
            {/* {state?.bookCover ||
              (isLoading ?
                <BookSkeleton /> :
                <img className="object-cover object-center w-full rounded largeCover h-1/2 lg:w-1/4"
                  alt={state?.title || book.title} src={state?.bookCover || book.cover} />)} */}


{state?.bookCover ? (
  <img
    className="object-cover object-center w-full rounded largeCover h-1/2 lg:w-1/4"
    alt={state?.title || book.title || "Book cover"}
    src={state?.bookCover}
    onError={(e) => {
      e.target.src = "fallback-image-url.jpg"; // Fallback if image fails to load
    }}
  />
) : isLoading ? (
  <BookSkeleton />
) : (
  <img
    className="object-cover object-center w-full rounded largeCover h-1/2 lg:w-1/4"
    alt={state?.title || book.title || "Book cover"}
    src={book.cover || "fallback-image-url.jpg"}
    onError={(e) => {
      e.target.src = "fallback-image-url.jpg"; // Fallback if image fails to load
    }}
  />
)}
            <div className="w-full lg:w-2/3 lg:pl-10 lg:mt-0">


              <h1 className="mb-1 line-clamp-4 pb-0.5 text-4xl tracking-tight libre-baskerville-regular">
                {state?.title || (isLoading ? <div className="w-2/3 h-10 mb-3 bg-gray-300 rounded"></div> : book?.title)}
              </h1>

              <p className="font-medium authorName fanwood-text-regular-italic">
                {state?.author || (isLoading ? <div className="w-40 h-4 bg-gray-300 rounded"></div>
                  : book?.author?.map((author) => author.name).join(', '))}
              </p>

              <br />
              {isLoading ? <DescriptionSkeleton /> : <div className="leading-relaxed bookDescription max-h-[240px] overflow-y-auto"><p>{book.description}</p></div>}

            </div>
          </div>

          {/*  */}

          <div className="mx-auto mt-10 lg:max-w-5xl">
            <div className="grid w-full grid-cols-2 gap-6 p-6 mb-10 lg:flex lg:items-center lg:justify-around lg:gap-0">

              <BookInfoItem label="Time to read" value={isLoading ? textLoading : readingTime} />
              {/* <BookInfoItem label="Publish date" value={new Date(book.publishDate).toLocaleDateString('en-US', { year: 'numeric', month: 'short' })} /> */}
              <BookInfoItem label="Pages" value={isLoading ? textLoading : book.pageCount} />
              <BookInfoItem label="Rating" value={isLoading ? textLoading : book.rating} />
              <BookInfoItem label="Category" value={isLoading ? textLoading : book.categories.filter(Boolean).slice(0, 2).join(', ')} />
            </div>

            {/* {similarBooks && similarBooks.length > 0 && ( */}
            <BookShelf title="Similar books" books={isLoading ? 'loading' : similarBooks} />
            {/* )} */}

            {/* {similarBooks && similarBooks.books && similarBooks.books.length > 0 && (
                <BookShelf books={similarBooks} />
              )} */}
          </div>
        </div>
      </section>
    </main>
  );
};

const BookInfoItem = ({ label, value, isLoading }) => (
  <div className="w-full text-center lg:pr-4 lg:border-r lg:border-[#eeeeee] lg:last:border-0">
    <h2 className="text-lg text-[#78716c] fanwood-text-regular-italic">{label}</h2>

    {isLoading ? <div className="h-4 bg-gray-200 rounded"></div> : <p className="text-base libre-baskerville-regular">{value}</p>}
  </div>
);

export default BookDetail;